import { render, staticRenderFns } from "./Wp_order_list.vue?vue&type=template&id=3a4939d2&scoped=true&"
import script from "./Wp_order_list.vue?vue&type=script&lang=js&"
export * from "./Wp_order_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4939d2",
  null
  
)

export default component.exports